import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllergensFooterComponent } from './allergens-footer.component';

@NgModule({
  declarations: [AllergensFooterComponent],
  imports: [CommonModule],
  exports: [AllergensFooterComponent],
})
export class AllergensFooterModule {}
